import React from 'react';
import Box from '@mui/material/Box';
import Checkbox from '@mui/material/Checkbox';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import RenderTextfieldHeader from '../../renderTextFieldHeader';
import FeedIcon from '@mui/icons-material/Feed';
import EditIcon from '@mui/icons-material/Edit';
import TrackChangesIcon from '@mui/icons-material/TrackChanges';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { colorTypes, columnTypes, dateConfig, regionalFields, renderDateCell, renderTextCell } from './columnTypes';
import { renderOcplcSelectHeader } from 'pages/ocplcDashboard/ocplcHelpers';
import { LOC_CHOICE_ID, LOC_MAPPING, LOCALIZATION_CHOICE_ID_TABLE, TOF_PROGRAM_MANAGEMENT } from 'constants/ocplcConstants';
import { Typography } from '@mui/material';


const createTextColumn = (field, label, filters, handleChange, getColor = null) => ({
    headerName: label,
    field,
    width: 155,
    sortable: false,
    headerClassName: 'dashboard-data-grid-headers',
    renderCell: (params) => renderTextCell(params.row[field], getColor ? getColor(params.row.status) : undefined),
    renderHeader: () => (
        <RenderTextfieldHeader colData={columnTypes[field]} label={label} filters={filters} handleChange={handleChange} />
    ),
});



const createSelectColumn = (field, label, filters, handleChange, dropdownData) => ({
    headerName: label,
    field,
    width: 155,
    sortable: false,
    headerClassName: 'dashboard-data-grid-headers',
    renderCell: (params) => renderTextCell(params.row[field]),
    renderHeader: () => renderOcplcSelectHeader(columnTypes[field], filters, label, handleChange, dropdownData),
});

const renderRawDateCell = (value) => (
  <Tooltip title={value}>
    <Typography variant='subtitle2'>{value}</Typography>
  </Tooltip>
);

const createDateColumn = (field, label, filters, handleChange) => ({
    headerName: label,
    field,
    width: 155,
    sortable: false,
    headerClassName: 'dashboard-data-grid-headers',
    renderCell: (params) => renderRawDateCell(params.row[field]),
    renderHeader: () => (
        <RenderTextfieldHeader colData={columnTypes[field]} label={label} filters={filters} handleChange={handleChange} />
    ),
});




export const getParameterColumns = (
    filters,
    parametersData = [],
    handleChange,
    countryList,
    businessModels,
    regionDropdown,
    handleViewModel,
    region,
    disableAction,
    handleFeedDialog,
    selectedTable
) => {

  

    const baseColumns = [
        createTextColumn('productFamily', 'Product Family', filters, handleChange,(status) => colorTypes[status] || 'grey'),
        createTextColumn('productGroup', 'Product Group', filters, handleChange),
        createSelectColumn('region', 'Region', filters, handleChange, regionDropdown),
        createTextColumn('parameterKey', 'Parameter', filters, handleChange),
        createTextColumn('parameterValue', 'Param Value', filters, handleChange),
        createTextColumn('parameterText', 'Param Text', filters, handleChange),
        createTextColumn('comments', 'Comments', filters, handleChange),
        createTextColumn('status', 'Status', filters, handleChange),
        createDateColumn('lastModifiedDate', 'When Changed', filters, handleChange),
    ].filter(Boolean);



    const authorColumn = createTextColumn('whoChanged', 'Author', filters, handleChange);

    const getAuditTitle=()=>{
        if (selectedTable === LOC_MAPPING){
            return "Audit Trail - Localization Mapping";
        }else if (selectedTable === LOC_CHOICE_ID){
            return "Audit Trail - Localization Choice ID Customization";
        }else{
            return 'Audit Trail - TOF Program Management';
        }
    }

   const actionColumn = {
    headerName: '',
    field: 'actions',
    width: 180,
    sortable: false,
    renderCell: (params) => {
        const actions = [
            {
                title: getAuditTitle(),
                icon: <FeedIcon />,
                onClick: () => handleFeedDialog(params.row, 'tofProgramManagement'),
            },
            {
                title: disableAction ? 'View' : 'Edit',
                icon: disableAction ? <VisibilityIcon /> : <EditIcon />,
                onClick: () => handleViewModel(params.row),
            }
        ];

        return (
            <Box onClick={(e) => e.stopPropagation()}>
                {actions.map((action, idx) => (
                    <Tooltip title={action.title} key={idx}>
                        <Button onClick={action.onClick} startIcon={action.icon} size="medium" />
                    </Tooltip>
                ))}
            </Box>
        );
    },
};


    return [...baseColumns, authorColumn, actionColumn];
};
